import { createRouter, createWebHistory, RouteRecordRaw, RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import HomeView from "../views/HomeView.vue";
import ExpendeduriasView from "@/views/ExpendeduriasView.vue";
import IncidentsView from "@/views/IncidentsView.vue";
import EnviosVIew from "@/views/EnviosView.vue";
import UtilsExpendeduria from "@/views/UtilsExpendeduria.vue";
import StockView from "@/views/StockView.vue";
import LoginView from "@/views/LoginView.vue";

import { useAuthStore } from '@/stores/useAuthStore'

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: { requiresAuth: false }
  },
  {  
    path: "/",
    name: "home",
    component: HomeView,
    meta: { requiresAuth: true },
  },
  {
    path: "/expendedurias",
    name: "expendedurias",
    component: ExpendeduriasView,
    meta: { requiresAuth: true },
  },
  {
    path: "/incidents",
    name: "incidents",
    component: IncidentsView,
    meta: { requiresAuth: true },
  },
  {
    path: "/envios",
    name: "envios",
    component: EnviosVIew,
    meta: { requiresAuth: true },
  },
  {
    path: "/stock",
    name: "stock",
    component: StockView,
    meta: { requiresAuth: true },
  },
  {
    path: "/utilsexpendeduria",
    name: "utilsexpendeduria",
    component: UtilsExpendeduria,
    meta: { requiresAuth: true },
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  const authStore = useAuthStore()

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.path === '/login' && authStore.isAuthenticated) {
    next('/')
  } else {
    next()
  }
})

export default router;
